import Box from "@mui/material/Box";

import { marketingPalette } from "./tokens";

/** The arrow every filled button on the marketing pages carries. */
export function ArrowIcon({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <Box
      component="svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      sx={{ flex: "0 0 auto" }}
    >
      <path
        d="M2.66675 8H13.3334"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66675 3.33334L13.3334 8.00001L8.66675 12.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
}

/** The tick beside every claim on the pricing page's metric and benefit rows. */
export function CheckIcon({ size = 18 }: { size?: number }) {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden
      sx={{ flex: "0 0 auto" }}
    >
      <circle cx="9" cy="9" r="9" fill={marketingPalette.discountInk} />
      <path
        d="M5 9.2L7.8 12L13 6.6"
        stroke="#FFFFFF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
}
